var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"physics"},[_c('div',{staticClass:"red"}),_c('div',{staticClass:"blue"})])}]

export { render, staticRenderFns }